import { Injectable, inject } from '@angular/core';
import { SettingsState } from '@library/utils/interfaces/settings-state.interface';
import { Actions } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import * as LangSelectors from './lang.selectors';
import { LangActions } from './lang.actions';

@Injectable({ providedIn: 'root' })
export class LangFacade {
  private readonly store = inject<Store<SettingsState>>(Store);
  protected actions$ = inject(Actions);

  lang$ = this.store.pipe(select(LangSelectors.getAllLangs));
  regLocale$ = this.store.pipe(select(LangSelectors.getRegLocale));

  translate(value: string, args: string[] = []) {
    return this.store.pipe(select(LangSelectors.getTranslation(value, args)));
  }

  loadLangs(aliases: { name: string; locale: string }[], locale?: string) {
    this.store.dispatch(
      LangActions.loadLangs({
        payload: {
          aliases,
          locale,
        },
      }),
    );
  }

  setLangs(langs: Record<string, string>, regLocale?: string) {
    this.store.dispatch(LangActions.loadLangsSuccess({ langs, reg_locale: regLocale }));
  }
}
